export enum ActionButtonTypeEnum {
  addAchievement = 'ADD_ACHIEVEMENT',
  approved = 'APPROVED',
  rejected = 'REJECTED'
}
